/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'tillbaka',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Refererar',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Åtgärder',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Fråga Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Ge feedback',
  'ai-smart-button.ai-actions.help.section.text': 'Hjälp',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Länka',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Omnämnande',
  'ai-smart-button.ai-actions.input.placeholder': 'Skriv vad du behöver',
  'ai-smart-button.ai-actions.input.send-button-label': 'Skicka',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NYTT',
  'ai-smart-button.ai-actions.no-results-heading': 'Fråga Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Skicka din uppmaning till Rovo för att starta en chatt.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Lägg till ikon',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Agentikon',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Automatiseringssymbol',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatiseringar',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Bläddra bland agenter',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Skapa agent',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Skapa automatisering',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'Hur kan jag hjälpa till?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Hej, {name}!',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Avfärda',
  'ai-smart-button.feedback-action.ask-question-option': 'Ställ en fråga',
  'ai-smart-button.feedback-action.can-contact-message':
    'Ja, {product}-team får kontakta mig för att lära sig om mina erfarenheter i syfte att förbättra Atlassians produkter och tjänster. Jag bekräftar {privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': 'Avbryt',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Välj en',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Beskriv buggen eller problemet',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Berätta vad du tycker',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Vad vill du veta?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Berätta för oss vad du vill ska förbättras',
  'ai-smart-button.feedback-action.leave-comment-option': 'Lämna en kommentar',
  'ai-smart-button.feedback-action.privacy-policy-link': 'sekretesspolicyn för {product}.',
  'ai-smart-button.feedback-action.report-bug-option': 'Rapportera en bugg',
  'ai-smart-button.feedback-action.research-participation-message': 'Jag vill delta i produktundersökningar',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Välj feedback',
  'ai-smart-button.feedback-action.submit-button-label': 'Skicka feedback',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Föreslå en förbättring',
  'ai-smart-button.feedback-action.title': 'Ge feedback',
  'ai-smart-button.feedback-item.icon-label': 'Feedbackikon',
  'ai-smart-button.reference.close-button-label': 'Stäng',
  'quick-summary.feedback.summary.placeholder': 'Vad gjorde Atlassian Intelligence bra? Vad kan förbättras?',
  'quick-summary.feedback.title': 'Hjälp oss att förbättra Atlassian Intelligence',
};
